import { render, staticRenderFns } from "./CasoListView.vue?vue&type=template&id=7ed955c0"
import script from "./CasoListView.vue?vue&type=script&lang=js"
export * from "./CasoListView.vue?vue&type=script&lang=js"
import style0 from "./CasoListView.vue?vue&type=style&index=0&id=7ed955c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports